import ListWithDescription from '@/components/elements/CustomLists/ListWithDescription'
import ImageWithContentLeft from '@/components/elements/ImageWithContent/ImageWithContentLeft'
import Paragraph from '@/components/elements/Paragraph/Paragraph'
import TitleBar from '@/components/elements/TitleBar/TitleBar'
import TitleWithContent from '@/components/elements/TitleWithContent/TitleWithContent'
import CustomLists from '@/components/elements/CustomLists/CustomLists'
import s1 from "@/assets/images/services/sheet_membrane.jpeg"

const SheetMembrane = () => {
  return (
    <>
      <div className="pb-0 px-4  2xl:px-40 xl:px-40 md:px-[3rem] my-[5rem]">
        <TitleBar title="Sheet Waterproofing Membrane" />

        <ImageWithContentLeft
          imageUrl={s1}
          title="Description"
          content="Sheet membranes are factory-manufactured sheets composed of bitumen, PVC, TPO, or synthetic rubber. They create a continuous, durable barrier when heat-welded or mechanically fixed to surfaces. Ideal for roofs, basements, tunnels, and podiums, sheet membranes deliver reliable waterproof protection ahead of liquid-applied systems."
        />

        <TitleWithContent title="Why Sheet Membranes Are Important">
          <Paragraph content="Sheet membranes offer high tensile strength, UV resistance, and low permeability, ensuring long-term waterproofing performance. Their factory-controlled thickness and consistent quality minimize installation errors and weak points common in field-applied membranes." />
          <CustomLists
            items={[
              [
                'Consistent factory-controlled thickness',
                'High tear and puncture resistance',
                'UV and chemical stability',
                'Rapid installation with heat-welding',
                'Minimal maintenance requirements'
              ]
            ]}
          />
        </TitleWithContent>

        <TitleWithContent title="Advantages of Sheet Membranes">
          <CustomLists
            items={[
              [
                'Predictable, uniform performance',
                'Fast-track installation',
                'Low permeability to water vapor',
              ],
              [
                'Superior puncture resistance',
                'Proven field durability' 
              ]
            ]}
            listStyle="disc"

          />
        </TitleWithContent>

        <TitleWithContent title="Applications of Sheet Membranes">
          <CustomLists
          listStyle='disc'
            items={[
              [
                'Flat and low-slope roofs',
                'Basement retaining walls',
                'Underground tunnels',
              ],
              [
                'Podium decks and terraces',
                'Planter boxes and green roofs'
              ]
            ]}
          />
        </TitleWithContent>

        <TitleWithContent title="Types of Sheet Membranes">
          <ListWithDescription
          layout='stacked'
            items={[
              {
                title: 'Bituminous Sheets:',
                content: ['SBS- and APP-modified bitumen membranes, torch-applied or self-adhesive.']
              },
              {
                title: 'PVC Membranes:',
                content: ['Polyvinyl chloride sheets offering weldable seams and excellent UV resistance.']
              },
              {
                title: 'TPO Membranes:',
                content: ['Thermoplastic polyolefin sheets known for heat-weldable seams and reflectivity.']
              },
              {
                title: 'EPDM Rubber Sheets:',
                content: ['Ethylene propylene diene monomer membranes with high elasticity and weather resistance.']
              }
            ]}
          />
        </TitleWithContent>

        

        <TitleWithContent title="Installation Process">
          <ListWithDescription
          layout='stacked'
          titleListType='decimal'
            items={[
              {
                title: 'Surface Preparation:',
                content: ['Clean and prime substrate to ensure adhesion; repair cracks and level surface.']
              },
              {
                title: 'Sheet Positioning:',
                content: ['Unroll membrane sheets and align seams per manufacturer layout.']
              },
              {
                title: 'Seaming:',
                content: ['Heat-weld or tape adjacent sheets to form watertight seams.']
              },
              {
                title: 'Detailing:',
                content: ['Install flashings, terminations, and corner welds at penetrations and edges.']
              },
              {
                title: 'Protection:',
                content: ['Apply protective screed or board over membrane in traffic or abutment areas.']
              }
            ]}
          />
        </TitleWithContent>


        <TitleWithContent title="Why Choose Us for Sheet Membrane Installation?">
          <Paragraph content="At [Your Company Name], our certified installers use industry-leading sheet membrane systems backed by comprehensive warranties. We ensure precise detailing, thorough quality control, and on-time project delivery." />
          <CustomLists
            listStyle='none'
            layout='stacked'
            items={[
              [
                'Certified torch-welding and heat-welding technicians',
                'Rigorous quality assurance protocols',
                'Comprehensive manufacturer warranties',
                'Customized system selection for any project'
              ]
            ]}
            bullets={[ ['🔧', '📋', '📜', ' 🧩'] ]}
          />
        </TitleWithContent>
      </div>
    </>
  )
}

export default SheetMembrane;
